export default function AddRound({
  width = "14",
  height = "18",
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 18"
    >
      <path
        id="Polygon_138"
        data-name="Polygon 138"
        d="M9,0l9,14H0Z"
        transform="translate(14) rotate(90)"
      />
    </svg>
  );
}
